import React, { Component } from 'react';
import { Button, Table, Jumbotron, Container, Row, Col, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import Auth from '../../../middleware/auth';
import funciones from '../../../middleware/funciones';
import Menu from '../../menu';
import config from '../../../config';
import Spinner from '../../subcomponent/spinner';
//import { saveAs } from 'file-saver';

class Gestiones extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const currentUserType = sessionStorage.getItem('tipo');
    const state = Auth.isAuthenticated();
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;

    this.state = {
      documentos: [],
      docPendientes: [],
      docProceso: [],
      docToSend: [],
      resoluciones: [],
      empresa: currentCompany,
      tipo: currentUserType,
      isLogin: state,
      tipo_documento: "",
      numero_inicial: "",
      numero_final: "",
      searchTipo: "",
      searchTipoDian: "",
      searchNumero: "",
      searchCliente: "",
      searchTransaccion: "",
      fecha_inicial: todayFormat,
      fecha_final: todayFormat,
      searchEstado: "",
      loading: false,
      visObsPDF: false,
      listAllPDF: 0
    };
  }

  componentDidMount() {
    const { empresa } = this.state
    const { tipo } = this.state
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/resoluciones/', datasend)
      .then(res => res.json())
      .then((data) => {
        const newData = [];
        data.forEach(element => {
          if (element.TIPO_DOCUMENTO === 'PS') {
            newData.push(element);
          }
        });
        this.setState({ resoluciones: newData });
      })
      .catch((error) => console.error(error))
  };

  updateInfo = () => {
    this.setState({ loading: true });
    const { empresa } = this.state
    const { tipo } = this.state
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      tipo_doc: this.state.tipo_documento
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/post/current', datasend)
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          const datos = data.data;
          this.setState({ documentos: datos, loading: false });
        } else {
          if (data.code === "0000") this.setState({ documentos: [], loading: false });
        }
      })
      .catch((error) => console.error(error))
  }

  buscar = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  impresionPDF = (id) => {
    const datasend = {
        method: 'GET',
        headers: {
            'Content-Type': 'blob',
            'empresa': this.state.empresa
        }
    }
    fetch(config.servBackEnd + '/post/getpdf/' + id, datasend)
        .then((res) => {
            if (res.ok) return res.blob();
        }).then(function (myBlob) {
            var objectURL = URL.createObjectURL(myBlob);
            document.querySelector('#pdf-frame').src = '';
            document.querySelector('#pdf-frame').src = objectURL;
            objectURL = URL.revokeObjectURL(myBlob);
        }).then(
            function () {
                window.setTimeout(function () {
                    document.querySelector('#pdf-frame').contentWindow.print();
                }, 1000)
            })
        .catch((err) => {
            console.error(err);
        })
}

  render() {
    //variables
    const facturas = this.state.documentos;
    const validacionUser = this.state.isLogin;
    const { searchTipo } = this.state;
    const { searchNumero } = this.state;
    const { searchCliente } = this.state;
    const { searchEstado } = this.state;
    const { loading } = this.state
    const { resoluciones } = this.state
    //funciones
    const updateInfo = this.updateInfo;
    const impresionPDF = this.impresionPDF;
    return (
      <div className="Menu">
        <Menu></Menu>
        <Jumbotron className="Jumbotron">
          <h2>Re impresion facturas POS</h2>
        </Jumbotron>
        {!validacionUser && <p>La sesion se ha cerrado por favor ingrese de nuevo</p>}
        {validacionUser &&
          <div>
            <iframe id="pdf-frame"></iframe>
            <Container fluid>
              <Row className="justify-content-md-center" >
                <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>TIPO</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control as="select" onChange={e => this.setState({ tipo_documento: e.target.value })} value={this.state.tipo_documento} >
                    <option value=""></option>
                    {
                      resoluciones.map((resoluion, i) => {
                        return <option key={'td' + i} value={resoluion.PREFIJO}>{resoluion.PREFIJO}</option>;
                      })
                    }
                  </Form.Control>
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO INICIAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_inicial: e.target.value })} value={this.state.numero_inicial} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO FINAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_final: e.target.value })} value={this.state.numero_final} />
                </Col>
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" name="actualizar" onClick={updateInfo}  >Actualizar Documentos </Button>
                </Col>
              </Row>
              <Row>
                <Table hover bordered responsive size="sm" className="table">
                  <thead>
                    <tr>
                      <th><input type="text" maxLength="2" size="3" name="searchTipo" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="10" size="11" name="searchNumero" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                    </tr>
                    <tr>
                      <th>Tipo Documento</th>
                      <th>Numero Documento</th>
                      <th>Nombre Cliente</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(!loading && facturas.length > 0) &&
                      facturas.map(function (currentData, index) {
                        if (currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                          && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                          && currentData.NOMBRE_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                          &&
                          (currentData.DOCUMENTO_ENVIADO.toLowerCase().search(searchEstado.toLowerCase()) > -1
                            || searchEstado === ""
                          )
                        ) {
                          return <tr name={index} key={index + "d0"}>
                            <td name="tipo" key={index + "d1"}>{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                            <td name="numero" key={index + "d3"}>{currentData.NUMERO_FACTURA_CABECERA}</td>
                            <td name="cliente" key={index + "d4"}>{currentData.NOMBRE_CLIENTE}</td>
                            <OverlayTrigger placement='top-start' overlay={<Tooltip>Impresion Tirilla</Tooltip>}>
                              <td key={index + "d10"}><Button className="buttonP" onClick={()=> impresionPDF (currentData.ID_FACTURA)} variant="outline-primary"></Button></td>
                            </OverlayTrigger>
                          </tr>;
                        } else {
                          return null;
                        }
                      })}
                    {(!loading && facturas.length === 0) &&
                      <tr>
                        <td colSpan="8"> CONSULTA SIN RESULTADOS </td>
                      </tr>
                    }
                  </tbody>
                </Table>
                {(loading) && <Spinner loading={loading} />}
              </Row>
            </Container>
          </div>
        }
      </div>
    );
  }
}
export default (Gestiones);